import { MapPin, Eye, UserCircle } from "lucide-react";

// TODO(plan-14): when content density grows enough to make screenshots
// look alive (see plans/14-marketing-refresh.md §Open follow-ups for
// the capture trigger), add an `image` + `alt` field per block and
// render an <img> at the top of each card. Until then, the cards stay
// text-first — gradient placeholders read as missing content, which
// is exactly what we're trying to avoid.
const blocks = [
  {
    icon: MapPin,
    title: "Meets",
    body: "Find Cars & Coffees, weekly cruise nights, and ad-hoc lot meets near you. RSVP and spot for free. With Pro, check in on the spot — your ride lands on the live roster, and the meet writes itself into that vehicle’s history.",
  },
  {
    icon: Eye,
    title: "Spotted & Social Feed",
    body: "Snap a build you’ve spotted and it’s in the public feed in seconds. Follow builders you like, rev posts you’re into, and leave threaded comments. @mention users or ride handles to pull them in.",
  },
  {
    icon: UserCircle,
    title: "Public Profiles & Ride Handles",
    body: "Claim a @handle for yourself and one for each ride — like @lava-911. Every vehicle gets its own URL at /r/<handle>. Share it on forums, in DMs, anywhere a link goes.",
  },
];

export function CommunitySection() {
  return (
    <section className="bg-[#151D2E] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="font-heading text-3xl font-bold text-[#E8EDF2] sm:text-4xl">
            Built around the community
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-[#7A8FA3]">
            The garage is private by default. The social side is opt-in — turn
            on what you want to share, keep the rest to yourself.
          </p>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {blocks.map((b) => {
            const Icon = b.icon;
            return (
              <div
                key={b.title}
                className="group flex flex-col rounded-xl border border-[#253448] bg-[#0C1222] p-8 transition-colors hover:border-[#4DB8C7]/40"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl border border-[#4DB8C7]/30 bg-[#4DB8C7]/10">
                  <Icon className="h-7 w-7 text-[#4DB8C7]" />
                </div>
                <h3 className="mt-6 font-heading text-xl font-semibold text-[#E8EDF2]">
                  {b.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[#7A8FA3]">
                  {b.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
